module.exports={"(optional)":"(valgfritt)","(required)":"(obligatorisk)"};